
























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Dropdown } from '@/store/models';

@Component({
  name: 'v-drop-down'
})
export default class VDropDown extends Vue {
  @Prop({ required: true }) placeholder?: string;
  @Prop({ required: true }) options?: Dropdown[];
  @Prop({ required: false }) error?: string;
  public show = false;
  public value = '';

  public expandDropDown() {
    this.show = !this.show;
  }

  @Emit()
  public onSelected(value: Dropdown) {
    this.value = value.name;
    this.show = false;
  }
}
